import { IRemittanceRepository, IGetRemittanceItemByIdParams, IGetRemittanceItemByIdRepositoryResponse } from "@/core/repositories/remittance";

export class GetRemittanceItemByIdUseCase {
  constructor(private readonly remittanceRepository: IRemittanceRepository) {}

  async execute(params: IGetRemittanceItemByIdParams, refetch: boolean = false): Promise<IGetRemittanceItemByIdRepositoryResponse> {
    return this.remittanceRepository.getRemittanceItemById(params, refetch);
  }
}
